module.exports = __webpack_public_path__ + "c8b26c1dce84591c241340a508c7863b.pdf";